import type { ColumnDef, GaugeMapping } from '@deckspace/types';
import { rowsToColumnar, getColumn } from '../shared/pivot.js';

export interface GaugeResult {
  gaugeValue: number;
  gaugeMin: number;
  gaugeMax: number;
}

export function prepGaugeSeries(
  rows: Record<string, unknown>[],
  _columnDefs: ColumnDef[],
  mapping: GaugeMapping
): GaugeResult {
  const tableData = rowsToColumnar(rows);
  if (tableData.rows.length === 0) {
    return { gaugeValue: 0, gaugeMin: 0, gaugeMax: 100 };
  }
  const value = Number(getColumn<number>(tableData, mapping.value)[0] ?? 0);
  const min = mapping.min ? Number(getColumn<number>(tableData, mapping.min)[0] ?? 0) : 0;
  const max = mapping.max ? Number(getColumn<number>(tableData, mapping.max)[0] ?? 100) : 100;
  return { gaugeValue: value, gaugeMin: min, gaugeMax: max };
}
